import { Node, mergeAttributes } from '@tiptap/core'
const NoLineSpacing = Node.create({
  name: 'no-line-spacing',

  // Needs to be higher than the priority for a paragraph (1000) because else tiptap would always switch back to p
  priority: 1001,

  addOptions () {
    return {
      HTMLAttributes: {},
    }
  },

  group: 'block',

  content: 'inline*',

  parseHTML () {
    return [
      { tag: 'div' },
    ]
  },

  renderHTML ({ HTMLAttributes }) {
    return ['div', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0]
  },

  addKeyboardShortcuts () {
    return {
      'Enter': () => {
        return this.editor.isActive(this.name) ? this.editor.commands.setHardBreak() : false
      },
    }
  },

  addCommands () {
    return {
      setNoLineSpacing: () => ({ commands }) => {
        return commands.setNode(this.name)
      },
    }
  },
})

export default NoLineSpacing
